<template>
  <div v-if="auth.user.selectedAccess.can_manage_staff">
    <app-header
      :title="$store.getters['translations/getLabel']('STAFF') || 'Staff'"
    />
    <b-container>
      <StaffList />
    </b-container>
  </div>
</template>

<script>
import $auth from '@/services/auth';
import StaffList from '@/components/StaffList';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    StaffList,
    AppHeader,
  },
  data() {
    return {
      auth: $auth,
    };
  },
};
</script>
